import { render, staticRenderFns } from "./GenericGroupFormView.vue?vue&type=template&id=f124381c&scoped=true"
import script from "./GenericGroupFormView.vue?vue&type=script&lang=js"
export * from "./GenericGroupFormView.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./GenericGroupFormView.vue?vue&type=style&index=1&id=f124381c&prod&scoped=true&lang=css"
import style2 from "./GenericGroupFormView.vue?vue&type=style&index=2&id=f124381c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f124381c",
  null
  
)

export default component.exports